const createRicosMarkExtension = (extension) => extension;

export { createRicosMarkExtension };
//# sourceMappingURL=create-ricos-mark-extension.js.map
